import { validatePlatformContent } from "utils/newMediaValidation";
import { isValidUrl } from "utils/utils";

/**
 * Validates Pinterest post content and media
 * @param {Object} params - The parameters for validation
 * @param {String} params.title - The pin title
 * @param {String} params.caption - The pin description
 * @param {String} params.link - The link for the pin
 * @param {Array} params.mediaList - Media files for the post
 * @param {String} params.board_id - The board ID to pin to
 * @param {Number} params.monthlyPosts - Available monthly posts
 * @returns {Boolean} - Whether the post has validation errors
 */
const validatePinterest = ({
  title,
  caption,
  link,
  mediaList,
  board_id,
  monthlyPosts,
}) => {
  const errorList = [];

  const { platformErrors, mediaList: mediaListValidated } =
    validatePlatformContent({
      mediaListRaw: mediaList,
      platform: "pinterest",
      caption,
      title
    });

  errorList.push(
    platformErrors.length > 0 ||
      mediaListValidated.some((media) => media.errors.length > 0)
  );
  errorList.push(!board_id);
  errorList.push(monthlyPosts < 1);
  errorList.push(link && !isValidUrl(link));

  return errorList.includes(true);
};

export default validatePinterest;
